import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ApiRegistration } from "src/api/types";
import Button from "src/components/Button";
import Input from "src/components/form/Input";
import Modal from "src/components/Modal";
import usePost from "src/hooks/rest/usePost";

interface RegistrationDenieModalProps {
	visible?: boolean;
	onClose: (data?: ApiRegistration) => Promise<unknown>;
	registrationId: number | string;
}

const RegistrationDenieModal = ({
	visible,
	onClose,
	registrationId,
}: RegistrationDenieModalProps) => {
	const { t } = useTranslation(["tasks", "buttons"]);
	const [motivation, setMotivation] = useState("");
	const [denieRegistration, loading] = usePost(
		`/company/registrations/${registrationId}/denie`
	);
	const [isConfirm, setIsConfirm] = useState(false);
	const [isClosing, setIsClosing] = useState(false);

	const handleClose = async (registration?: ApiRegistration) => {
		setIsConfirm(false);
		setIsClosing(true);
		await onClose(registration);
		setIsClosing(false);
	};
	const handleDenie = () => {
		denieRegistration({
			deny_motivation: motivation,
		}).then(({ data }) => {
			setMotivation("");
			handleClose(data);
		});
	};
	return (
		<Modal
			title={t("title", {
				ns: "tasks",
				keyPrefix: "registration-denie-modal",
			})}
			visible={visible || false}
			loading={isClosing}
			{...{ onClose }}
		>
			{isConfirm ? (
				<div className="flex flex-col gap-4">
					<div className="">
						<strong>
							{t("confirm.title", {
								ns: "tasks",
								keyPrefix: "registration-denie-modal",
							})}
						</strong>
						<p>
							{t("confirm.description", {
								ns: "tasks",
								keyPrefix: "registration-denie-modal",
							})}
						</p>
					</div>
					<p className="description">{motivation}</p>

					<div className="flex flex-col gap-4 mt-8">
						<Button
							onClick={handleDenie}
							loading={loading || isClosing}
							className="gtm-werkgever-dashboard-opdracht-afwijzen-modal--cta-bevestigen"
							disabled={!motivation}
						>
							{t("confirm.button", {
								ns: "tasks",
								keyPrefix: "registration-denie-modal",
							})}
						</Button>
						<Button
							onClick={() => setIsConfirm(false)}
							type="gray"
							className="gtm-werkgever-dashboard-opdracht-afwijzen-modal--button-annuleren"
						>
							{t("cancel", {
								ns: "buttons",
							})}
						</Button>
					</div>
				</div>
			) : (
				<>
					<p className="mb-4">
						{t("description", {
							ns: "tasks",
							keyPrefix: "registration-denie-modal",
						})}
					</p>
					<Input
						name="motivation"
						label={t("label", {
							ns: "tasks",
							keyPrefix: "registration-denie-modal",
						})}
						placeholder={t("placeholder", {
							ns: "tasks",
							keyPrefix: "registration-denie-modal",
						})}
						multiline
						value={motivation}
						onChange={(key, value) => setMotivation(value)}
					/>
					<div className="buttons">
						<Button
							onClick={onClose}
							type="gray"
							className="gtm-werkgever-dashboard-opdracht-afwijzen-modal--button-annuleren"
						>
							{t("cancel", {
								ns: "buttons",
							})}
						</Button>
						<Button
							onClick={() => setIsConfirm(true)}
							{...{ loading }}
							className="gtm-werkgever-dashboard-opdracht-afwijzen-modal--cta-bevestigen"
							disabled={!motivation}
						>
							{t("denie", {
								ns: "buttons",
							})}
						</Button>
					</div>
				</>
			)}
		</Modal>
	);
};

export default RegistrationDenieModal;
